/**
 * Checks if code is in list of supported crypto codes
 */
export function isCryptoCode(code: string): code is SUPPORTED_CRYPTO_CODES {
  return KNOWN_CRYPTO_CODES.includes(
    code.toUpperCase() as SUPPORTED_CRYPTO_CODES
  );
}

/**
 * Get the number of decimals used for supported crypto. Returns undefined for unknown codes
 */
export const getCryptoDecimals = <T extends string>(code: T) =>
  (isCryptoCode(code)
    ? CRYPTO_DECIMALS[code.toUpperCase()]
    : undefined) as T extends SUPPORTED_CRYPTO_CODES ? number : undefined;

/**
 * Returns name for https://cryptologos.cc/logos/
 */
export const getCryptoCDNNameFromCode = <T extends string>(code: T) =>
  (isCryptoCode(code)
    ? CRYPTO_CODE_CDN_NAME[code.toUpperCase()]
    : undefined) as T extends SUPPORTED_CRYPTO_CODES ? string : undefined;

/**
 * UTILS / TYPES
 */
type SUPPORTED_CRYPTO_CODES = "BTC" | "ETH" | "USDT" | "USDC";
type MapCryptoTo<V> = { [code in SUPPORTED_CRYPTO_CODES]: V };
const KNOWN_CRYPTO_CODES: SUPPORTED_CRYPTO_CODES[] = [
  "BTC",
  "ETH",
  "USDT",
  "USDC",
];
const CRYPTO_DECIMALS: MapCryptoTo<number> = {
  BTC: 8,
  ETH: 18,
  USDT: 6,
  USDC: 6,
};

/**
 * Matches name for format of https://cryptologos.cc/logos/
 */
const CRYPTO_CODE_CDN_NAME: MapCryptoTo<string> = {
  BTC: "bitcoin",
  ETH: "ethereum",
  USDT: "tether",
  USDC: "usd-coin",
};
